export default "__VITE_ASSET__e4427791__"